import React from 'react';
import getToken from "../../helpers/getToken";
import ReactS3Uploader from "react-s3-uploader";
import { ProgressBar, Button } from "react-bootstrap";
import ImgToolTip from '../ImgTooltip';
import Alert from "react-s-alert";

// import {UploadIcon} from '../svgs'
const UploadPresentationICo = ({ presentation, intl, setProgress, presentationAddFileAction, label, progress }) => {
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  // const [showFileSizeWarning, setShowFileSizeWarning] = React.useState(false);
  console.log("UploadPresentationICo page test 1");
  
  return (
    <React.Fragment>
      <ReactS3Uploader
        placeholder="Presentation"
        className="inputfile"
        id={`ppt-for-${presentation._id}-${presentation.ppt.length}`}
        style={{
          display: "none",
        }}
        name={`ppt-for-${presentation._id}-${presentation.ppt.length}`}
        signingUrl="/s3"
        signingUrlMethod="GET" // default "GET"
        accept=".ppt,.pptx,.pps,.pdf"
        preprocess={(file, next) => {
          setProgress(1);
          Alert.warning(
            intl.formatMessage({
              id: "button.uploadingPresentation",
            })
          );
          next(file);
        }}
        onProgress={(p) => {
          if (p === 0) {
            setProgress(p + 1);
          } else {
            setProgress(p)
          }
        }}
        onError={() => {
          setProgress(0);
          Alert.error(
            intl.formatMessage({
              id: "error.file-upload",
            })
          );
          setShowError(true); 
            setTimeout(() => {
              setProgress(0);
              setShowError(false);  
            }, 3000);
        }}
        onFinish={(url) => {
          setProgress(0);
          presentationAddFileAction(presentation._id, url.publicUrl);
          Alert.success(
            intl.formatMessage({
              id: "input.presentation.presentationUploaded",
            })
          );
          setShowSuccess(true);
            setTimeout(() => {
              setProgress(0); 
              setShowSuccess(false);
            }, 3000);
          // handleClose() Uncomment if u want modal to close after succesfull upload
        }} // url.publicUrl
        signingUrlHeaders={{
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getToken(),
        }}
        signingUrlQueryParams={{
          event_id: presentation.event_id,
          speaker_id: presentation.speaker_id,
          presentation_id: presentation._id,
        }}
        // signingUrlWithCredentials // pass auth creds via CORS
        uploadRequestHeaders={{
          "x-amz-acl": "public-read",
        }}
        contentDisposition="auto"
        server={process.env.REACT_APP_API_HOST}
      />
      <label
        style={{marginBottom: 0}}
        htmlFor={`ppt-for-${presentation._id}-${presentation.ppt.length}`}
        className="btn btn-primary"
      >
        <ImgToolTip intl={intl} placement="right" tooltiptext="input.presentation.presentationUpload" id="tooltip-upload-ppt" img="/icons/upload.png" />
        {/* <UploadIcon /> */}
        {
          label ? label : ''
        }
      </label>
      {
      progress !== 0  && <div className="upload-file-progress-container">
        <div className="upload-file-progress">
          <p>{intl.formatMessage({id: "button.uploadingPresentation"})} { (showError || showSuccess ) && <Button onClick={() => setProgress(0)} type="button"><img src="/icons/close.png" alt="close" /></Button> }</p>
          <div className="progress-container">
            <ProgressBar now={progress} label={`${progress}%`} />
            <span className="status-message text-success">{showSuccess && intl.formatMessage({ id: "input.presentation.presentationUploaded" }) }</span>
            <span className="status-message text-danger">{showError && intl.formatMessage({ id: "error.file-upload" }) }</span>
            {/* <span className="status-message text-warning">{showFileSizeWarning && intl.formatMessage({ id: "error.fileTooBig" }) }</span> */}
          </div>
        </div>
      </div>
    }
    </React.Fragment>
  )
}

export default UploadPresentationICo;
